import React, {useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { isProvider} from "../../features/user";
import {isLoading, getMessage, showMessage} from "../../features/common";
import {useTranslation } from 'react-i18next';
import Header from "./Header";
import Nav from './Nav';
import { delay } from '../../Helper';


const Frame = ({ children, headerWhite, showMenu, showNav, showBack, backOveride }) => {
    const dispatch = useDispatch();
    const isUserProvider = useSelector(isProvider);
    const loading = useSelector(isLoading);
    const message = useSelector(getMessage);
    const { t } = useTranslation();

    useEffect(() => {
        if(message) {
            hideMessage();
        }
    }, [message]);

    const hideMessage = async () => {
        await delay(4000);
        dispatch(showMessage({message : null}));
    }

    const getChildren = (children) => {
        return children;
    }

    return <div className={`frame ${(showNav && !isUserProvider) ? 'nav-frame' : ''} ${headerWhite ? 'background-white' : ''}`}>
        <Header headerWhite={headerWhite} showMenu ={showMenu} showBack={showBack} backOveride={backOveride}></Header>
        {!loading?<div className="content">
            {getChildren(children)}
        </div>:<div className="center-div align-items-center height-80vh">
            <div className='loader'></div>
        </div>}
        {(showNav && !isUserProvider)?<Nav></Nav>:null}
        {message && <div className='bottom-message'>{t(message)}</div>}
     </div>;
};


export default Frame;